import i18next from "i18next";
import { RiCopperCoinFill } from "react-icons/ri";

import { normalizePrice } from "../../../utils";

import { Badge, Row } from "./style";

/**
 * Кэшбек b2c под итоговой суммой: поле cashback из API (prebook / order) в валюте cashback_currency.
 * 0 или нет поля — ничего не рисуем (кэшбек у реквизита выключен или правило вознаграждения не подобралось).
 * accrued — кэшбек по заказу уже зачислен на баланс (cashback_accrued).
 */
const CashbackBadge = ({ amount, currency, accrued = false }) => {
  const value = Number(amount);

  if (!Number.isFinite(value) || value <= 0) return null;

  return (
    <Row>
      <Badge title={accrued ? undefined : i18next.t("cashback_hint")}>
        <RiCopperCoinFill className="cashback-coin" />
        {i18next.t(accrued ? "cashback_accrued_label" : "cashback_label")} + {normalizePrice(value)} {currency}
      </Badge>
    </Row>
  );
};

export default CashbackBadge;
